import { forEachConfig } from '../framework/DspConfig';
export class Extron {
    constructor(socket, log) {
        this.socket = socket;
        this.log = log;
        this.products = [
            {
                modelNumber: '-LCEDTpRifVwRzGvfXiJ',
                modelName: 'IN1508',
                partNumber: '60-569-01',
            },
            {
                modelNumber: '-LCEDWOgikcF8USId4zr',
                modelName: 'IN1608 xi',
                partNumber: '60-1238-01',
            },
            {
                modelNumber: '-LL5Wcz2PL427UYTBnS3',
                modelName: 'SW2 HD 4K',
                partNumber: '60-1603-01',
            },
            {
                modelNumber: '-LL5WebTl0L6P9B5iC-p',
                modelName: 'SW4 HD 4K',
                partNumber: '60-1604-01',
            },
            {
                modelNumber: '-LL5WgAzpQ05jZCnCZJz',
                modelName: 'SW6 HD 4K',
                partNumber: '60-1605-01',
            },
            {
                modelNumber: '-LL5WibjXH0m-VDcEJ1r',
                modelName: 'SW8 HD 4K',
                partNumber: '60-1606-01',
            },
            {
                modelNumber: '-LQxjTsl7pkexzC7R7Sh',
                modelName: 'DTP CrossPoint 82 4K',
                partNumber: '60-1583-01',
                supportsBangQuery: true,
            },
            {
                modelNumber: '-Mj-Btjj3g11wa-VRTfm',
                modelName: 'DTP CrossPoint 84',
                partNumber: '60-1368-01',
                supportsBangQuery: true,
            },
            {
                modelNumber: '-LQxjUuabdG7N0VUheIE',
                modelName: 'DTP CrossPoint 84 4K',
                partNumber: '60-1515-01',
                supportsBangQuery: true,
            },
            {
                modelNumber: '-LQxjW6cqOwgv7nHi4RB',
                modelName: 'DTP CrossPoint 86 4K',
                partNumber: '60-1382-01',
                supportsBangQuery: true,
            },
            {
                modelNumber: '-LQxjX4z4fD22aBP5sge',
                modelName: 'DTP CrossPoint 108 4K',
                partNumber: '60-1381-01',
                supportsBangQuery: true,
            },
            {
                modelNumber: '-LWXbVuCtpk17uYbSkKZ',
                modelName: 'SW2 USB',
                partNumber: '60-952-01',
            },
            {
                modelNumber: '-LWXbmcF2V3qKblJSL4b',
                modelName: 'SW4 USB',
                partNumber: '60-953-01',
            },
            {
                modelNumber: '-LWXbq323tIAUSw0g9z0',
                modelName: 'SW4 USB Plus',
                partNumber: '60-954-01',
            },
            {
                modelNumber: '-LbU9Sdm1xjy-kaEEZwC',
                modelName: 'DXP 44 HD 4K',
                partNumber: '60-1493-01',
            },
            {
                modelNumber: '-LbU9WCsvA740ie3wMoz',
                modelName: 'DXP 84 HD 4K',
                partNumber: '60-1494-01',
            },
            {
                modelNumber: '-LbU9YwT1pBjaedvuHor',
                modelName: 'DXP 88 HD 4K',
                partNumber: '60-1495-01',
            },
            {
                modelNumber: '-LbU9abf1Np08r_AeFSJ',
                modelName: 'DXP 168 HD 4K',
                partNumber: '60-1496-01',
            },
            {
                modelNumber: '-LbU9gkPXxoLZ1nzS9I9',
                modelName: 'DXP 1616 HD 4K',
                partNumber: '60-1497-01',
            },
            {
                modelNumber: '-M240A3k-uQCw69yi4cJ',
                modelName: 'IN1806',
                partNumber: '60-1663-01',
            },
            {
                modelNumber: '-M240Cm32g-Sgc9SZyrF',
                modelName: 'IN1808',
                partNumber: '60-1615-01',
            },
            {
                modelNumber: '-MCx2b-tTmZrOO_JKhxu',
                modelName: 'IN1604',
                partNumber: '60-1457-01',
            },
            {
                modelNumber: '-Mj-EI0DyjevoVaHx3ek',
                modelName: 'DMP 44 LC',
                partNumber: '60-1095-01',
            },
            {
                modelNumber: '-Mj-EPSclr1awY8Mex-I',
                modelName: 'DMP 64',
                partNumber: '60-1054-01',
            },
            {
                modelNumber: '-Mj-EVZvCCXtRCgfJ-QO',
                modelName: 'MVC 121 Plus',
                partNumber: '60-1096-01',
            },
            {
                modelNumber: '-Mj-EbE5cfM_aejN4AgO',
                modelName: 'MLA VC10 Plus',
                partNumber: '60-1090-01',
            },
            {
                modelNumber: '-NtLdBa9uJZwZPXgotcz',
                modelName: 'NetPA U 1002',
                partNumber: '60-1767-01',
            },
            {
                modelNumber: '-NtLdCs7hPY8jWIhogMe',
                modelName: 'NetPA U 1004',
                partNumber: '60-1766-01',
            },
        ];
        this.audioChannels = {};
        this.displayBlank = false;
        this.displayFreeze = false;
        this.firmwareVersion = '1.00';
        this.groupTypes = {};
        this.product = this.products[0];
        this.videoOutputs = Array(16).fill('1');
        this.asyncHandlers = [
            {
                name: 'commonMuteQuery',
                regExp: /\x1bM(\d+)AU$/i,
                callback: (match) => {
                    const key = `mute${match[1]}`;
                    if (!this.audioChannels[key]) {
                        this.audioChannels[key] = { gain: 0, mute: false };
                    }
                    this.socket.send(`DsM${match[1]}*${this.audioChannels[key].mute ? '1' : '0'}`);
                },
            },
            {
                name: 'commonMuteSet',
                regExp: /\x1bM(\d+)\*(\d)AU/i,
                callback: (match) => {
                    const key = `mute${match[1]}`;
                    if (!this.audioChannels[key]) {
                        this.audioChannels[key] = { gain: 0, mute: false };
                    }
                    this.audioChannels[key].mute = match[2] === '1';
                    this.socket.send(`DsM${match[1]}*${this.audioChannels[key].mute ? '1' : '0'}`);
                },
            },
            {
                name: 'displayBlank',
                regExp: /(\d*)B/i,
                callback: (match) => {
                    if (match[1])
                        this.displayBlank = match[1] === '0' ? false : true;
                    this.socket.send(`Vmt${this.displayBlank ? '1' : '0'}`);
                },
            },
            {
                name: 'displayFreeze',
                regExp: /(\d*)F/i,
                callback: (match) => {
                    if (match[1])
                        this.displayFreeze = match[1] === '0' ? false : true;
                    this.socket.send(`Frz${this.displayFreeze ? '1' : '0'}`);
                },
            },
            {
                name: 'firmwareVersion',
                regExp: /\*?Q/i,
                callback: (match) => {
                    this.socket.send(`${this.firmwareVersion}`);
                },
            },
            {
                name: 'gainSet',
                regExp: /\x1bG(\d+)\*([-\+]?\d+)AU/i,
                callback: (match) => {
                    const key = `gain${match[1]}`;
                    if (!this.audioChannels[key]) {
                        this.audioChannels[key] = { gain: 0, mute: false };
                    }
                    this.audioChannels[key].gain = parseInt(match[2], 10);
                    this.socket.send(`DsG${match[1]}*${this.audioChannels[key].gain.toString()}`);
                },
            },
            {
                name: 'gainQuery',
                regExp: /\x1bG(\d+)AU$/i,
                callback: (match) => {
                    const key = `gain${match[1]}`;
                    if (!this.audioChannels[key]) {
                        this.audioChannels[key] = { gain: 0, mute: false };
                    }
                    this.socket.send(`DsG${match[1]}*${this.audioChannels[key].gain.toString()}`);
                },
            },
            {
                name: 'groupMuteOrVolumeQuery',
                regExp: /\x1bD(\d+)GRPM$/i,
                callback: (match) => {
                    var _a;
                    const key = `group${match[1]}`;
                    const groupNum = parseInt(match[1], 10);
                    const groupType = (_a = this.groupTypes[groupNum]) !== null && _a !== void 0 ? _a : (groupNum > 4 ? 'mute' : 'gain');
                    if (!this.audioChannels[key]) {
                        this.audioChannels[key] = { gain: 0, mute: false };
                    }
                    const value = groupType === 'mute'
                        ? this.audioChannels[key].mute
                            ? '+00001'
                            : '+00000'
                        : this.audioChannels[key].gain;
                    this.socket.send(`GrpmD${match[1]}*${value}`);
                },
            },
            {
                name: 'groupMuteSet',
                regExp: /\x1bD(\d+)\*(0|1)GRPM/i,
                callback: (match) => {
                    const key = `group${match[1]}`;
                    if (!this.audioChannels[key]) {
                        this.audioChannels[key] = { gain: 0, mute: false };
                    }
                    this.audioChannels[key].mute = match[2] === '1';
                    this.socket.send(`GrpmD${match[1]}*${this.audioChannels[key].mute ? '+00001' : '+00000'}`);
                },
            },
            {
                name: 'groupTypeQuery',
                regExp: /\x1bP(\d+)GRPM$/i,
                callback: (match) => {
                    var _a;
                    const groupNum = parseInt(match[1], 10);
                    const groupType = (_a = this.groupTypes[groupNum]) !== null && _a !== void 0 ? _a : (groupNum > 4 ? 'mute' : 'gain');
                    // 0 is returned if the group isn't configured, but we emulate all configured
                    this.socket.send(`GrpmP${match[1]}*${groupType === 'gain' ? '6' : '12'}`);
                },
            },
            {
                name: 'groupVolumeSet',
                regExp: /\x1bD(\d+)\*([-\+]?\d+)GRPM/i,
                callback: (match) => {
                    const key = `group${match[1]}`;
                    if (!this.audioChannels[key]) {
                        this.audioChannels[key] = { gain: 0, mute: false };
                    }
                    this.audioChannels[key].gain = parseInt(match[2], 10);
                    this.socket.send(`GrpmD${match[1]}*${this.audioChannels[key].gain.toString()}`);
                },
            },
            {
                name: 'matrixRouteMultipleOutputs',
                regExp: /^(\d+)\*(\d+)([%!])$/i,
                callback: (match) => {
                    const inputIndex = parseInt(match[2], 10) - 1;
                    const allOrVid = match[3] === '!' ? 'All' : 'Vid';
                    if (match[1] && match[2])
                        this.videoOutputs[inputIndex] = match[1];
                    this.socket.send(`Out${match[2]} In${this.videoOutputs[inputIndex]} ${allOrVid}`);
                },
            },
            {
                name: 'matrixRouteQueryMultipleOutputs',
                regExp: /^(\d+)%$/i,
                callback: (match) => {
                    const inputIndex = parseInt(match[1], 10) - 1;
                    this.socket.send(`Out${match[1]} In${this.videoOutputs[inputIndex]} Vid`);
                },
            },
            {
                name: 'matrixRouteSingleOutput',
                regExp: /^(\d*)!$/i,
                callback: (match) => {
                    // In the DTP products, 3! queries output 3 while in the SW HD products 3! sets the
                    // single output to use input 3.
                    if (this.product.supportsBangQuery) {
                        if (match[1]) {
                            const outputNum = parseInt(match[1], 10) - 1;
                            this.socket.send(`Out${match[1]} In${this.videoOutputs[outputNum]} All`);
                        }
                        else {
                            this.socket.send(`E10 : ERROR Command not found.`);
                            this.log.error(`invalid command: ${match[0]}`);
                        }
                    }
                    else {
                        if (match[1])
                            this.videoOutputs[0] = match[1];
                        this.socket.send(`In${this.videoOutputs[0]} All`);
                    }
                },
            },
            {
                name: 'modelNumber',
                regExp: /^1I$/i,
                callback: (match) => {
                    this.socket.send(`${this.product.modelName}`);
                },
            },
            {
                name: 'nameQuery',
                regExp: /\x1b(\d+)N([IO])/i,
                callback: (match) => {
                    const typeCode = match[2].toLowerCase();
                    const channelType = match[2] === 'O' ? 'Output' : 'Input';
                    const channelNum = parseInt(match[1], 10);
                    this.socket.send(`Nm${typeCode}${match[1]},${channelType}${channelNum}`);
                },
            },
            {
                name: 'partNumber',
                regExp: /N/i,
                callback: (match) => {
                    this.socket.send(`Pno${this.product.partNumber}`);
                },
            },
            {
                name: 'verboseMode',
                regExp: /\x1b(\d)CV/i,
                callback: (match) => {
                    this.socket.send(`Vrb${match[1]}`);
                },
            },
            {
                name: 'volume',
                regExp: /^(-?\d*)V$/i,
                callback: (match) => {
                    const key = 'volume';
                    if (!this.audioChannels[key]) {
                        this.audioChannels[key] = { gain: 0, mute: false };
                    }
                    if (match[1])
                        this.audioChannels[key].gain = parseInt(match[1], 10);
                    this.socket.send(`Vol${this.audioChannels[key].gain.toString()}`);
                },
            },
            {
                name: 'volumeMute',
                regExp: /^(\d*)Z$/i,
                callback: (match) => {
                    const key = 'volume';
                    if (!this.audioChannels[key]) {
                        this.audioChannels[key] = { gain: 0, mute: false };
                    }
                    if (match[1])
                        this.audioChannels[key].mute = match[1] === '1' ? true : false;
                    this.socket.send(`Amt${this.audioChannels[key].mute ? '1' : '0'}`);
                },
            },
            {
                name: 'error',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`E10 : ERROR Command not found.`);
                },
            },
        ];
    }
    onConfigure(config) {
        let modelNumber = config.modelNumber;
        // Use MVC 121 for volume control if model number is "auto-detect" or undefined.
        if (modelNumber === undefined || modelNumber === '-Mj-Ei1OBYjLMZLZE-D9') {
            modelNumber = '-Mj-EVZvCCXtRCgfJ-QO';
        }
        for (const product of this.products) {
            if (product.modelNumber === modelNumber) {
                this.product = product;
                return;
            }
        }
        this.log.error(`unrecognized model number: "${config.modelNumber}"`);
        forEachConfig(config, (path, type, config) => {
            if (typeof config === 'string') {
                // The old method assumed groups 1-4 were gain groups and 5+ were mute groups.
                const groupNum = parseInt(config.substring(1), 10);
                this.groupTypes[groupNum] = groupNum > 4 ? 'mute' : 'gain';
            }
            else {
                const groupNum = parseInt(config.channel.substring(1), 10);
                this.groupTypes[groupNum] = config.gain === undefined ? 'mute' : 'gain';
            }
        });
    }
}
Extron.emulatorType = 'socketEmulator';
Extron.key = '-LCEDOmeRpYN8cVsR6cq';
